import gql from 'graphql-tag';

export const RutrEventFragment = gql`
  fragment RutrEventFragment on RollUpTheRimEvent {
    createdAt
    eventId
    prizeId
    redemptionCode
    timelineId
    type
    rollMetadata {
      source
    }
  }
`;

export const RutrConsolidatedEventFragment = gql`
  fragment RutrConsolidatedEventFragment on RollUpTheRimConsolidatedEvent {
    dateEarned
    dateRevealed
    eventId
    prizeId
    redemptionCode
    referenceId
    timelineId
    type
    rollMetadata {
      source
    }
  }
`;
